import { callApiToServer } from "../callApi";

export async function addSubCategory(authtoken, subCategoryObject) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify(subCategoryObject);

    let endUrl = "v1/auth/admin/add-sub-category";
    console.log("endUrl printed here", endUrl);

    let responseData = await callApiToServer(body, header, "POST", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
